<template>
    <div>
        <form @submit.prevent="submit">
            <h4>Purchase Order Comment</h4>
            <validated-input v-model="purchaseOrderComment" placeholder="Enter comment to include on all purchase orders" />
            <div class="d-flex mt-2">
                <b-button variant="primary" type="submit">Save</b-button>
                <b-spinner v-if="status === 'saving'" small class="ml-2 align-self-center"></b-spinner>
            </div>
        </form>
    </div>
</template>

<script>
export default {
  props: {
    entity: {
      type: Object,
      required: true
    },
    entityType: {
      type: String,
      required: true,
      validator: value => ['distributor', 'supplier'].includes(value)
    }
  },
  data() {
    return {
      purchaseOrderComment: null,
      status: null
    }
  },
  created() {
    if (this.entity && this.entity.purchaseOrderComment) {
      this.purchaseOrderComment = this.entity.purchaseOrderComment;
    }
  },
  methods: {
    async submit() {
      this.status = 'saving';
      
      try {
        const updatedEntity = { 
          ...this.entity, 
          purchaseOrderComment: this.purchaseOrderComment
        };
        
        if (this.entityType === 'distributor') {
          const { updateDistributor } = await import('@/api/distributors');
          await updateDistributor(updatedEntity);
        } else if (this.entityType === 'supplier') {
          const { updateDistSupplier } = await import('@/api/distsuppliers');
          await updateDistSupplier(updatedEntity.supplierId || updatedEntity._id, {
            purchaseOrderComment: updatedEntity.purchaseOrderComment
          });
        }
        
        this.$emit('change', updatedEntity);
        
        this.$store.dispatch('notification/show', {
          type: 'success',
          text: 'Purchase order comment saved successfully!'
        });
        
        this.status = null;
      } catch (error) {
        console.error(`Error saving purchase order comment for ${this.entityType}:`, error);
        this.$store.dispatch('notification/show', {
          type: 'error',
          text: 'Failed to save purchase order comment'
        });
        this.status = null;
      }
    }
  }
}
</script>
